export default __webpack_public_path__ + "static/media/menuIcon.76cbae7a.svg";